require('./bootstrap');
import Vue from 'vue';
import App from './App.vue'
import { BootstrapVue, IconsPlugin } from 'bootstrap-vue'
import router from './router/index.js'
import store from './store'
import Notifications from 'vue-notification'
import LNotifications from './mixins/notifications'
import VueCarousel from 'vue-carousel';
import VueCookies from 'vue-cookies'
import Toasted from 'vue-toasted';

Vue.use(BootstrapVue)
Vue.use(IconsPlugin)
Vue.use(VueCarousel);
Vue.use(Notifications)
Vue.mixin(LNotifications)
Vue.use(VueCookies)

Vue.use(Toasted, {
  iconPack: 'fontawesome',
})

Vue.mixin({
  methods: {
    slugify(str) {
      str = str.replace(/^\s+|\s+$/g, ''); // trim
      str = str.toLowerCase();

      // remove accents, swap ñ for n, etc
      var from = "àáäâèéëêìíïîòóöôùúüûñç·/_,:;";
      var to   = "aaaaeeeeiiiioooouuuunc------";
      for (var i=0, l=from.length ; i<l ; i++) {
          str = str.replace(new RegExp(from.charAt(i), 'g'), to.charAt(i));
      }

      str = str.replace(/[^a-z0-9 -]/g, '') // remove invalid chars
          .replace(/\s+/g, '-') // collapse whitespace and replace by -
          .replace(/-+/g, '-'); // collapse dashes

      return str;
    }
  }
})

const app = new Vue({
    el: '#app',
    router,
    store,
    render: app => app(App),
});